import { fetch } from '../fetchWrapper/fetch';
import { AdjustmentType, IPriceRule, RoundingMethod, RoundingType } from '../../types/price.types';
import { API_URL, PRICE_SCHEME_HEADER, Status } from '../constants';

export interface ICreatePriceRuleRequestBody {
  name?: string;
  price_band_id?: string;
  extension_instance_id?: string;
  pricing_category_id?: string;
  adjustment: {
    type: AdjustmentType;
    value?: number;
  };
  rounding: {
    type: RoundingType;
    value?: number;
    method?: RoundingMethod;
  };
}

export const createPriceRules = async (
  requestBody: ICreatePriceRuleRequestBody[],
  priceSchemeId: string,
): Promise<IPriceRule[]> => {
  try {
    const response = await fetch(`${API_URL}/pricing/price-rules`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        [PRICE_SCHEME_HEADER]: priceSchemeId,
      },
      body: JSON.stringify(requestBody),
    });

    if (response.status !== Status.SUCCESS) {
      throw new Error('Failed to create price rule');
    }

    return (await response.json()).data;
  } catch (error) {
    console.error('Error creating price rule:', error);
    throw error;
  }
};
